import type {
  RfpFieldGroupEventType,
  RfpFieldGroupLocation,
  RfpFieldGroupBudget,
  RfpFieldGroupFunctionRoomSetup,
  RfpFieldGroupAddEvents,
} from '@/features/RfpForm/types/RfpFields'
import type { ConfigurationMessage } from './RfpConfigurationWarningTypes'
import { useI18n } from 'vue-i18n'


export const checkValidityEventTypes = (field: RfpFieldGroupEventType): ConfigurationMessage[] => {
  const { t } = useI18n()

  const allMessages: ConfigurationMessage[] = []
  if (field.event_types.length === 0 && field.is_mandatory_event_type) {
    allMessages.push({
      type: 'error',
      message: t('Event type dropdown is mandatory but does not contain any value to select.'),
    })
  }

  return allMessages
}

export const checkValidityLocations = (field: RfpFieldGroupLocation): ConfigurationMessage[] => {
  const { t } = useI18n()

  const allMessages: ConfigurationMessage[] = []
  if (field.locations.length === 0) {
    allMessages.push({
      type: 'error',
      message: t('Location - Hotel name dropdown is empty. Please check your hotels have filled the Meeting Broker ID.'),
    })
  }

  return allMessages
}

export const checkValidityBudget = (field: RfpFieldGroupBudget): ConfigurationMessage[] => {
  const { t } = useI18n()

  const allMessages: ConfigurationMessage[] = []
  if (field.currencies.length === 0 && field.is_mandatory_currency) {
    allMessages.push({
      type: 'error',
      message: t('Currencies dropdown is mandatory but does not contain any value to select.'),
    })
  }

  return allMessages
}

export const checkValidityRoomSetup = (
  field: RfpFieldGroupFunctionRoomSetup,
): ConfigurationMessage[] => {
  const { t } = useI18n()

  const allMessages: ConfigurationMessage[] = []
  if (field.function_room_types.length === 0) {
    allMessages.push({
      type: 'warning',
      message: t('Room Setup Radio Group does not contain any value to choose from.'),
    })

    if (field.is_mandatory) {
      allMessages.push({
        type: 'error',
        message: t('Room Setup Radio Group is mandatory but does not contain any value to choose.'),
      })
    }
  }

  return allMessages
}

export const checkValidityAddEvents = (field: RfpFieldGroupAddEvents): ConfigurationMessage[] => {
  const { t } = useI18n()

  const allMessages: ConfigurationMessage[] = []
  if (field.events.length === 0) {
    allMessages.push({
      type: 'warning',
      message: t('Adding Events Checkbox Group does not contain any value to choose from.'),
    })

    if (field.is_mandatory) {
      allMessages.push({
        type: 'error',
        message:
          t('Adding Events Checkbox Group is mandatory but does not contain any value to choose.'),
      })
    }
  }

  return allMessages
}
